var timer2;
var timer2_1;
var slider2_1;

var load_1 = false;
var load_2 = false;
var load_3 = false;
var load_4 = false;
var load_5 = false;
var load_6 = false;

function preloader() {
    setTimeout(function() {
        $('html, body').css('overflow-y', 'visible');
        $('.async-preloader').css('opacity', '0');
        setTimeout(function() {
            $('.async-preloader').hide();
            startInterval2();
        }, 300);
    }, 1500);
}

function hydrateAsyncCarouselImages($carousel) {
    $carousel.find('.owl-item.active img[loading="lazy"], .owl-item.center img[loading="lazy"]').each(function() {
        this.setAttribute('loading', 'eager');
    });
}

function keepAsyncCarouselImagesHydrated($carousel) {
    hydrateAsyncCarouselImages($carousel);
    $carousel.on('changed.owl.carousel translated.owl.carousel refreshed.owl.carousel resized.owl.carousel', function(event) {
        setTimeout(function() {
            hydrateAsyncCarouselImages($(event.currentTarget));
        }, 0);
    });
}

$(document).ready(function() {
     $('#page-h7-section-1 .aos-init').addClass('aos-animate');
    preloader();

    $('#home-section-1 .aos-init').addClass('aos-animate');
    
    slider2_1 = $("#home-section-2_1 .owl-carousel").owlCarousel({
        items: 1,
        dots: true,
        nav: true,
        loop: true,
        smartSpeed: 500,
        touchDrag: false,
        mouseDrag: false,
        navText: ['<i class="fa-solid fa-chevron-left"></i>', '<i class="fa-solid fa-chevron-right"></i>'],
    }).on('changed.owl.carousel', function(event) {

        startInterval2();

        $('#home-section-2_1 .hide-it').removeClass('shown');

        clearTimeout(timer2_1);
        timer2_1 = setTimeout(function() {
            $('#home-section-2_1 .hide-it').addClass('shown');
        }, 500);
    });

    $("#home-section-2_1").swipe({
        swipeLeft: function () {
            slider2_1.trigger('next.owl.carousel');
        },
        swipeRight: function () {
            slider2_1.trigger('prev.owl.carousel');
        }
    });
    
    pageSection2();

    let timer7;
    let total7 = $("#home-section-7 .owl-carousel .item").length;
    $('#home-section-7 .bar-page .page').html('01/' + twoDigits(total7));
    $('#home-section-7 .bar-page .bar .span').width((100/total7)+'%');

    let slider7 = $("#home-section-7 .owl-carousel").owlCarousel({
        items: 3,
        slideBy: 1,
        dots: false,
        nav: true,
        loop: true,
        center: true,
        autoplay: true,
        autoplayTimeout: 5000,
        touchDrag: false,
        mouseDrag: false,
        smartSpeed: 300,
        navText: ['<i class="fa-solid fa-chevron-left"></i>', '<i class="fa-solid fa-chevron-right"></i>'],
        responsive: {
            0 : {
                items: 1,
                margin: 20,
            },
            360 : {
                items: 1,
                margin: 20,
            },
            375 : {
                items: 1,
                margin: 20,
            },
            390 : {
                items: 1,
                margin: 20,
            },
            414 : {
                items: 1,
                margin: 20,
            },
            428 : {
                items: 1,
                margin: 20,
            },
            480 : {
                items: 1,
                margin: 20,
            },
            768 : {
                items: 1,
                margin: 30,
            },
            800 : {
                items: 1,
                margin: 30,
            },
            1024 : {
                items: 3,
                margin: 0,
            },
            1280 : {
                items: 3,
                margin: 0,
            },
            1366 : {
                items: 3,
                margin: 0,
            },
            1440 : {
                items: 3,
                margin: 0,
            },
            1536 : {
                items: 3,
                margin: 0,
            },
            1600 : {
                items: 3,
                margin: 0,
            },
            1920 : {
                items: 3,
                margin: 0,
            },
            2560 : {
                items: 3,
                margin: 0,
            },
        }
    }).on('changed.owl.carousel', function(event) {
        clearTimeout(timer7);
        timer7 = setTimeout(function(){
            let page = $(event.target).find('.owl-item.center .item').data('slide');
            $('#home-section-7 .bar-page .bar .span').width(((100/total7)*page)+'%');
            $('#home-section-7 .bar-page .page').html(twoDigits(page) + '/' + twoDigits(total7))
        }, 50);
    });
    keepAsyncCarouselImagesHydrated(slider7);

    let slider8 = $("#home-section-8 .owl-carousel").owlCarousel({
        items: 2,
        dots: false,
        nav: true,
        loop: false,
        smartSpeed: 500,
        stagePadding: 150,
        margin: 50,
        navText: ['<i class="fa-solid fa-chevron-left"></i>', '<i class="fa-solid fa-chevron-right"></i>'],
        responsive: {
            0 : {
                items: 1,
                stagePadding: 50,
                margin: 20,
            },
            360 : {
                items: 1,
                stagePadding: 50,
                margin: 20,
            },
            375 : {
                items: 1,
                stagePadding: 50,
                margin: 20,
            },
            390 : {
                items: 1,
                stagePadding: 50,
                margin: 20,
            },
            414 : {
                items: 1,
                stagePadding: 50,
                margin: 20,
            },
            428 : {
                items: 1,
                stagePadding: 50,
                margin: 20,
            },
            480 : {
                items: 1,
                stagePadding: 50,
                margin: 20,
            },
            768 : {
                items: 2,
                stagePadding: 50,
                margin: 30,
            },
            800 : {
                items: 2,
                stagePadding: 50,
                margin: 30,
            },
            1024 : {
                items: 2,
                stagePadding: 50,
                margin: 30,
            },
            1280 : {
                items: 2,
                stagePadding: 100,
                margin: 40,
            },
            1366 : {
                items: 2,
                stagePadding: 100,
                margin: 40,
            },
            1440 : {
                items: 2,
                stagePadding: 130,
                margin: 50,
            },
            1536 : {
                items: 2,
                stagePadding: 130,
                margin: 50,
            },
            1600 : {
                items: 2,
                stagePadding: 150,
                margin: 50,
            },
            1920 : {
                items: 2,
                stagePadding: 150,
                margin: 50,
            },
            2560 : {
                items: 2,
                stagePadding: 150,
                margin: 50,
            },
        }
    });
    keepAsyncCarouselImagesHydrated(slider8);

});

$(window).scroll(function() {
    pageSection2();
});

function startInterval2() { 
    clearInterval(timer2);

    timer2 = setInterval(function(){
        slider2_1.trigger('next.owl.carousel');
    }, 5000);
}

function twoDigits(num) {
    return num < 10 ? "0" + num : num;
}



function calculateBottomValues($element) {
    let elementHeight = $element.outerHeight();
    let viewportHeight = $(window).height();
    
    let elementOffset = $element.offset();
    let elementTop = elementOffset.top - $(window).scrollTop();
    let elementBottom = elementTop + elementHeight;
    
    let scrollPercentage = Math.min(100, Math.max(0, (elementBottom - viewportHeight) / elementHeight * 100));
    
    let firstValue = 30 - (scrollPercentage * 30 / 100);
    let secondValue = 70 + (scrollPercentage * 30 / 100);
    
    let thirdValue;

    if (window.innerWidth < 768) {
        thirdValue = 30 - (scrollPercentage * 30 / 100);
    } else if (window.innerWidth < 1280) {
        thirdValue = 50 - (scrollPercentage * 50 / 100);
    } else {
        thirdValue = 80 - (scrollPercentage * 80 / 100);
    }

    return [Math.max(0, firstValue), Math.min(100, secondValue), Math.max(0, thirdValue)];
}


$('#home-section-8 .owl-carousel img').on('mouseover', function() {
    if (wSize >= 1280) {
        $('#home-section-8 .owl-carousel img').css('border-radius', '0');
        $(this).css('border-radius', '50%');
    }
}).on('mouseleave', function() {
    if (wSize >= 1280) {
        $(this).css('border-radius', '0');
    }
});


const lottieSection2 = document.getElementById('page-l3-section-2');
const lottieDesktop2 = document.getElementById('lottie-2');
const lottieMobile2 = document.getElementById('lottie-2_m');
let mobileLottie2InteractivityInitialized = false;

function initializeMobileLottie2() {
    if (!lottieMobile2 || mobileLottie2InteractivityInitialized || typeof LottieInteractivity === 'undefined') {
        return;
    }

    try {
        LottieInteractivity.create({
            player: '#lottie-2_m',
            mode: 'scroll',
            actions: [{visibility: [0, 1], type: 'seek', frames: [0, 100]}]
        });
        mobileLottie2InteractivityInitialized = true;
    } catch (error) {
        // The load/ready listeners below retry once the player has finished upgrading.
    }
}

function prepareMobileLottie2() {
    if (!lottieMobile2) {
        return;
    }

    lottieMobile2.addEventListener('load', initializeMobileLottie2, {once: true});
    lottieMobile2.addEventListener('ready', initializeMobileLottie2, {once: true});

    if (!lottieMobile2.getAttribute('src') && lottieMobile2.dataset.src) {
        lottieMobile2.setAttribute('src', lottieMobile2.dataset.src);
    }

    if (typeof lottieMobile2.getLottie === 'function') {
        try {
            const animationOrPromise = lottieMobile2.getLottie();

            if (animationOrPromise && typeof animationOrPromise.then === 'function') {
                animationOrPromise.then(function(animation) {
                    if (animation) {
                        initializeMobileLottie2();
                    }
                }).catch(function() {});
            } else if (animationOrPromise) {
                initializeMobileLottie2();
            }
        } catch (error) {}
    }
}

function initializeDesktopLottie2() {
    if (window.innerWidth < 992 || !lottieDesktop2 || typeof path_lottie_2 === 'undefined') {
        return;
    }

    const animScroll2 = bodymovin.loadAnimation({
        container: lottieDesktop2,
        path: path_lottie_2,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        name: 'animScroll2'
    });

    animScroll2.addEventListener('DOMLoaded', function () {
        const tl2 = new TimelineMax({repeat: 0});
        tl2.to({frame: 0}, 1, {
            frame: animScroll2.totalFrames - 1,
            onUpdate: function() {
                animScroll2.goToAndStop(Math.round(this.target.frame), true);
            },
            Ease: Linear.easeNone
        });

        const controller2 = new ScrollMagic.Controller();
        new ScrollMagic.Scene({
            triggerElement: '#page-l3-section-2',
            offset: $('#page-l3-section-2 #lottie-2').height() / 2,
            duration: 3000
        }).setTween(tl2).setPin('#page-l3-section-2 #lottie-2').addTo(controller2);
        new ScrollMagic.Scene({
            triggerElement: '#page-l3-section-2',
            offset: $('#page-l3-section-2 #lottie-2').height() / 1.8,
            duration: 3000
        }).setTween(tl2).setPin('#page-l3-section-2 .sticky').addTo(controller2);
    });
}

if (window.innerWidth < 992) {
    prepareMobileLottie2();
} else if (lottieSection2 && 'IntersectionObserver' in window) {
    const lottieObserver2 = new IntersectionObserver(function(entries, observer) {
        if (entries[0].isIntersecting) {
            initializeDesktopLottie2();
            observer.disconnect();
        }
    }, {rootMargin: '0px'});
    lottieObserver2.observe(lottieSection2);
} else if (lottieSection2) {
    initializeDesktopLottie2();
}


var $section2 = $('#page-l3-section-2');
function pageSection2() {
    let percentage = calculateSectionPercentage($section2);

    if (percentage < 20) {
        setTimeout(function() {
            if (!$('#page-l3-section-2 .desktop .hide-it:eq(0)').hasClass('shown'))
                $('#page-l3-section-2 .desktop .hide-it:eq(0)').addClass('shown')
        }, 300);
        setTimeout(function() {
            if (!$('#page-l3-section-2 .desktop .hide-it:eq(1)').hasClass('shown'))
                $('#page-l3-section-2 .desktop .hide-it:eq(1)').addClass('shown')
        }, 400);
        setTimeout(function() {
            if (!$('#page-l3-section-2 .desktop .hide-it:eq(2)').hasClass('shown'))
                $('#page-l3-section-2 .desktop .hide-it:eq(2)').addClass('shown')
            if (!$('#page-l3-section-2 .desktop .hide-it:eq(3)').hasClass('shown'))
                $('#page-l3-section-2 .desktop .hide-it:eq(3)').addClass('shown')
        }, 600);
        setTimeout(function() {
            if (!$('#page-l3-section-2 .desktop .hide-it:eq(4)').hasClass('shown'))
                $('#page-l3-section-2 .desktop .hide-it:eq(4)').addClass('shown')
            if (!$('#page-l3-section-2 .desktop .hide-it:eq(5)').hasClass('shown'))
                $('#page-l3-section-2 .desktop .hide-it:eq(5)').addClass('shown')
        }, 700);
        setTimeout(function() {
            if (!$('#page-l3-section-2 .desktop .hide-it:eq(6)').hasClass('shown'))
                $('#page-l3-section-2 .desktop .hide-it:eq(6)').addClass('shown')
            if (!$('#page-l3-section-2 .desktop .hide-it:eq(7)').hasClass('shown'))
                $('#page-l3-section-2 .desktop .hide-it:eq(7)').addClass('shown')
        }, 800);
        setTimeout(function() {
            if (!$('#page-l3-section-2 .desktop .hide-it:eq(8)').hasClass('shown'))
                $('#page-l3-section-2 .desktop .hide-it:eq(8)').addClass('shown')
        }, 900);

        setTimeout(function() {
            if (!$('#page-l3-section-2 .mobile .hide-it:eq(0)').hasClass('shown'))
                $('#page-l3-section-2 .mobile .hide-it:eq(0)').addClass('shown')
        }, 300);
        setTimeout(function() {
            if (!$('#page-l3-section-2 .mobile .hide-it:eq(1)').hasClass('shown'))
                $('#page-l3-section-2 .mobile .hide-it:eq(1)').addClass('shown')
        }, 400);
        setTimeout(function() {
            if (!$('#page-l3-section-2 .mobile .hide-it:eq(2)').hasClass('shown'))
                $('#page-l3-section-2 .mobile .hide-it:eq(2)').addClass('shown')
            if (!$('#page-l3-section-2 .mobile .hide-it:eq(3)').hasClass('shown'))
                $('#page-l3-section-2 .mobile .hide-it:eq(3)').addClass('shown')
        }, 600);
        setTimeout(function() {
            if (!$('#page-l3-section-2 .mobile .hide-it:eq(4)').hasClass('shown'))
                $('#page-l3-section-2 .mobile .hide-it:eq(4)').addClass('shown')
            if (!$('#page-l3-section-2 .mobile .hide-it:eq(5)').hasClass('shown'))
                $('#page-l3-section-2 .mobile .hide-it:eq(5)').addClass('shown')
        }, 700);
        setTimeout(function() {
            if (!$('#page-l3-section-2 .mobile .hide-it:eq(6)').hasClass('shown'))
                $('#page-l3-section-2 .mobile .hide-it:eq(6)').addClass('shown')
            if (!$('#page-l3-section-2 .mobile .hide-it:eq(7)').hasClass('shown'))
                $('#page-l3-section-2 .mobile .hide-it:eq(7)').addClass('shown')
        }, 800);
        setTimeout(function() {
            if (!$('#page-l3-section-2 .mobile .hide-it:eq(8)').hasClass('shown'))
                $('#page-l3-section-2 .mobile .hide-it:eq(8)').addClass('shown')
        }, 900);
    }
    else {
        setTimeout(function() {
            if ($('#page-l3-section-2 .desktop .hide-it:eq(0)').hasClass('shown'))
                $('#page-l3-section-2 .desktop .hide-it:eq(0)').removeClass('shown')
        }, 300);
        setTimeout(function() {
            if ($('#page-l3-section-2 .desktop .hide-it:eq(1)').hasClass('shown'))
                $('#page-l3-section-2 .desktop .hide-it:eq(1)').removeClass('shown')
        }, 400);
        setTimeout(function() {
            if ($('#page-l3-section-2 .desktop .hide-it:eq(2)').hasClass('shown'))
                $('#page-l3-section-2 .desktop .hide-it:eq(2)').removeClass('shown')
            if ($('#page-l3-section-2 .desktop .hide-it:eq(3)').hasClass('shown'))
                $('#page-l3-section-2 .desktop .hide-it:eq(3)').removeClass('shown')
        }, 600);
        setTimeout(function() {
            if ($('#page-l3-section-2 .desktop .hide-it:eq(4)').hasClass('shown'))
                $('#page-l3-section-2 .desktop .hide-it:eq(4)').removeClass('shown')
            if ($('#page-l3-section-2 .desktop .hide-it:eq(5)').hasClass('shown'))
                $('#page-l3-section-2 .desktop .hide-it:eq(5)').removeClass('shown')
        }, 700);
        setTimeout(function() {
            if ($('#page-l3-section-2 .desktop .hide-it:eq(6)').hasClass('shown'))
                $('#page-l3-section-2 .desktop .hide-it:eq(6)').removeClass('shown')
            if ($('#page-l3-section-2 .desktop .hide-it:eq(7)').hasClass('shown'))
                $('#page-l3-section-2 .desktop .hide-it:eq(7)').removeClass('shown')
        }, 800);
        setTimeout(function() {
            if ($('#page-l3-section-2 .desktop .hide-it:eq(8)').hasClass('shown'))
                $('#page-l3-section-2 .desktop .hide-it:eq(8)').removeClass('shown')
        }, 900);

        setTimeout(function() {
            if ($('#page-l3-section-2 .mobile .hide-it:eq(0)').hasClass('shown'))
                $('#page-l3-section-2 .mobile .hide-it:eq(0)').removeClass('shown')
        }, 300);
        setTimeout(function() {
            if ($('#page-l3-section-2 .mobile .hide-it:eq(1)').hasClass('shown'))
                $('#page-l3-section-2 .mobile .hide-it:eq(1)').removeClass('shown')
        }, 400);
        setTimeout(function() {
            if ($('#page-l3-section-2 .mobile .hide-it:eq(2)').hasClass('shown'))
                $('#page-l3-section-2 .mobile .hide-it:eq(2)').removeClass('shown')
            if ($('#page-l3-section-2 .mobile .hide-it:eq(3)').hasClass('shown'))
                $('#page-l3-section-2 .mobile .hide-it:eq(3)').removeClass('shown')
        }, 600);
        setTimeout(function() {
            if ($('#page-l3-section-2 .mobile .hide-it:eq(4)').hasClass('shown'))
                $('#page-l3-section-2 .mobile .hide-it:eq(4)').removeClass('shown')
            if ($('#page-l3-section-2 .mobile .hide-it:eq(5)').hasClass('shown'))
                $('#page-l3-section-2 .mobile .hide-it:eq(5)').removeClass('shown')
        }, 700);
        setTimeout(function() {
            if ($('#page-l3-section-2 .mobile .hide-it:eq(6)').hasClass('shown'))
                $('#page-l3-section-2 .mobile .hide-it:eq(6)').removeClass('shown')
            if ($('#page-l3-section-2 .mobile .hide-it:eq(7)').hasClass('shown'))
                $('#page-l3-section-2 .mobile .hide-it:eq(7)').removeClass('shown')
        }, 800);
        setTimeout(function() {
            if ($('#page-l3-section-2 .mobile .hide-it:eq(8)').hasClass('shown'))
                $('#page-l3-section-2 .mobile .hide-it:eq(8)').removeClass('shown')
        }, 900);
    }
}
